<template>
  <div>
    <div :id="id"></div>
  </div>
</template>
<script>
function getPlaintText(html) {
  if (html) {
    var plainText = $("<p>" + html + "</p>").text();
    return plainText || "";
  } else {
    return "";
  }
}

export default {
  name: "UE",
  data() {
    var ueId = "ue_" + this.ueConfig.index;
    this.ueConfig.index = this.ueConfig.index + 1;

    return {
      content: this.value,
      editorOption: {
        lang:
          (abp.utils.getCookieValue("Language.CultureName") || "").indexOf(
            "en"
          ) > -1
            ? "en-US"
            : "zh-CN",
        placeholder: this.l("QINGSHURUNEIRONG"),
        minHeight: this.height,
        toolbar: [
          ["style", ["bold", "italic", "underline", "clear"]],
          ["font", ["strikethrough", "superscript", "subscript"]],
          ["fontsize", ["fontsize"]],
          ["color", ["color"]],
          ["para", ["ul", "ol", "paragraph"]],
          ["insert", ["picture", "link", "video", "table", "hr"]],
          ["misc", ["codeview", "undo", "redo"]]
        ]
      },
      id: ueId,
      ueLoaded: false
    };
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    },
    txt: {},
    height: {
      default: 200
    }
  },
  methods: {
    onEditorChange(content, $editable) {
      this.content = content;
      this.$emit("input", this.content);
      this.$emit("update:txt", getPlaintText(this.content));
    },
    onEditorBlur(quill) {}
  },
  watch: {
    value(val, oldValue) {
      if (val != this.content) {
        this.content = val;
        if (this.ueLoaded) {
          $("#" + this.id).summernote("code", this.content);
        }
      }
    }
  },
  mounted() {
    this.$nextTick(_ => {
      let vm = this;
      var $note = $("#" + this.id);
      $note.summernote({
        ...this.editorOption,
        ...this.config,
        callbacks: {
          onChange: function(contents, $editable) {
            vm.onEditorChange(contents, $editable);
          },
          onInit: function() {
            vm.ueLoaded = true;
          }
        }
      });

      $note.summernote("code", this.content);
    });
  },
  destroyed() {
    $("#" + this.id).summernote("destroy");
  }
};
</script>
<style>
.edui-default {
  line-height: 22px;
}

.note-editor {
  height: 100%;
}

.note-group-select-from-files input[type="file"] {
  display: block;
}

.note-modal-backdrop {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: none;
  background: #000;
  -webkit-opacity: 0.5;
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
  -ms-filter: alpha(opacity=50);
  filter: alpha(opacity=50);
}
.note-modal {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: none;
  overflow: hidden;
  -webkit-opacity: 1;
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
  -ms-filter: alpha(opacity=100);
  filter: alpha(opacity=100);
}
</style>



// WEBPACK FOOTER //
// UE.vue?048bab12